import { render } from "./logo-plc.svg?vue&type=template&id=5a29a406?inline"
const script = {}
script.render = render

export default script